import { connect } from 'react-redux';
import { setLocalStorage } from '../../helpers/tools';
import { updateOther } from '../../actions';
import OtherSettings from '../../components/sections/pluginSettings/OtherSettings';

const mapStateToProps = state => {
  return {
    data: state.other,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateState: data => {
      if (data.isValid) {
        setLocalStorage('other', JSON.stringify(data));
      }
      dispatch(updateOther(data));
    },
  };
};

const OtherSettingsRedux = connect(mapStateToProps, mapDispatchToProps)(OtherSettings);

export default OtherSettingsRedux;
